/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of NumberField.
 * @typedef {Object} NumberFieldType
 *
 * @typedef {QuestionFormFieldType & NumberFieldType} NumberFieldExtendType
 */

/**
 * Represents a number form field.
 * @class
 */
export class NumberField extends QuestionFormField {}
